// extracted by mini-css-extract-plugin
export default {"container":"customer_container__eW5+M","user":"customer_user__VEg-+","message":"customer_message__J3ULD"};